import * as Types from '../types';

interface AuthcodeRedirectParams {
  baseUrl: string;
  userId: string;
  primaryEmail: string;
  product: string;
  productAccessId: string;
  costCenterId: string;
}

interface AuthcodeRedirectAction {
  type: string;
  payload: AuthcodeRedirectParams;
}

export function authcodeRedirect({
  baseUrl,
  userId,
  primaryEmail,
  product,
  productAccessId,
  costCenterId,
}: AuthcodeRedirectParams): AuthcodeRedirectAction {
  const action: AuthcodeRedirectAction = {
    type: Types.CLIENT_AUTHCODE_REDIRECT,
    payload: {
      baseUrl,
      userId,
      primaryEmail,
      product,
      productAccessId,
      costCenterId,
    },
  };
  return action;
}
